import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRentvineLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_45871_66549)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z",
				fill: "#00A54F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M20 6.10352L28.3846 14.4881C28.9476 15.0511 29.2639 15.8147 29.2639 16.6109V24.6312L20 15.3674V6.10352Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.9992 15.3672L11.6147 23.7517C11.0517 24.3148 10.7354 25.0784 10.7354 25.8746V33.8949L19.1199 25.5104C19.6829 24.9473 19.9992 24.1837 19.9992 23.3875V15.3672Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_45871_66549",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			fill: "white"
		})
	}) })]
});
export default SvgRentvineLogo;
